__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = function(name, initScope) {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = function(msg) { return typeof console !== "undefined" && console.warn && console.warn(msg); };
	var uniqueName = "onboarding-campaigns";
	var register = function(name, version, factory, eager) {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = function(id) {
		var handleError = function(err) { warn("Initialization of sharing external failed: " + err); };
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = function(module) { return module && module.init && module.init(__webpack_require__.S[name], initScope); }
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@material-ui/core", "4.11.4", function() { return Promise.all([__webpack_require__.e(596), __webpack_require__.e(352), __webpack_require__.e(832), __webpack_require__.e(747), __webpack_require__.e(56)]).then(function() { return function() { return __webpack_require__(2352); }; }); });
			register("@material-ui/styles", "4.11.5", function() { return Promise.all([__webpack_require__.e(377), __webpack_require__.e(747), __webpack_require__.e(385)]).then(function() { return function() { return __webpack_require__(1377); }; }); });
			register("react-dom", "18.2.0", function() { return Promise.all([__webpack_require__.e(164), __webpack_require__.e(747)]).then(function() { return function() { return __webpack_require__(4164); }; }); });
			register("react-particles", "2.3.3", function() { return Promise.all([__webpack_require__.e(656), __webpack_require__.e(747), __webpack_require__.e(561)]).then(function() { return function() { return __webpack_require__(2431); }; }); });
			register("react", "18.2.0", function() { return __webpack_require__.e(791).then(function() { return function() { return __webpack_require__(2791); }; }); });
			register("tsparticles", "2.3.4", function() { return Promise.all([__webpack_require__.e(656), __webpack_require__.e(0), __webpack_require__.e(853)]).then(function() { return function() { return __webpack_require__(4000); }; }); });
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(function() { return initPromises[name] = 1; });
};